<template>
  <div class="view-list-wrap">
    <ankh-list :show-search-form="false">
      <template #btn-group>
        <el-button type="primary" @click.native="onAdd">{{ $t('新增') }}</el-button>
        <el-button
            type="danger"
            :disabled="selectedRows.length === 0"
            @click.native="onBatchDelete"
        >
          {{ $t('批量删除') }} ({{ selectedRows.length }})
        </el-button>
      </template>

      <template #table="{height}">
        <div class="table-scroll-x">
          <vxe-table
              ref="tableRef"
              :data="tableData"
              :height="height"
              border
              resizable
              :show-overflow="true"
              :show-header-overflow="true"
              :scroll-x="{enabled: true, gt: 20}"
              :scroll-y="{enabled: true, gt: 20}"
              :loading="loading"
              :checkbox-config="{ highlight: true }"
              @checkbox-change="onCheckboxChange"
              @checkbox-all="onCheckboxAll"
          >
            <!-- 选择框列 -->
            <vxe-column type="checkbox" width="60" fixed="left"></vxe-column>

            <vxe-column title="适用人群">
              <template #default="{row}">
                {{ formatAgeRange(row) }}
              </template>
            </vxe-column>

            <vxe-column title="营养元素" field="refElement">
              <template #default="{row}">{{ elMap[row["refElement"]] }}</template>
            </vxe-column>

            <vxe-column title="性别" field="gender">
              <template #default="{row}">{{ genderMap[row["gender"]] }}</template>
            </vxe-column>

            <vxe-column title="活动水平" field="refLabor">
              <template #default="{row}">{{ laborMap[row["refLabor"]] }}</template>
            </vxe-column>

            <vxe-column title="算法A" field="refAlgorithm">
              <template #default="{row}">{{ algorithmMap[row["refAlgorithm"]] }}</template>
            </vxe-column>

            <vxe-column title="算法B" field="refAlgorithmMax">
              <template #default="{row}">{{ algorithmMap[row["refAlgorithmMax"]] }}</template>
            </vxe-column>

            <vxe-column title="PA值" field="pa"/>

            <vxe-column title="推荐摄入量">
              <template #default="{row}">
                {{ formatRange(row)}}
              </template>
            </vxe-column>

            <!-- 操作列 -->
            <vxe-column :title="$t('操作')" fixed="right" width="120">
              <template #default="{ row }">
                <el-link :underline="false" type="primary" @click="handleEdit(row)">{{ $t('编辑') }}</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false" type="danger" @click="onDelete(row)">{{ $t('删除') }}</el-link>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
      </template>
    </ankh-list>

    <!--  编辑弹窗  -->
    <el-dialog :visible.sync="editDialogVisible"
               :title="$t('编辑')"
               width="720px"
               :close-on-click-modal="false"
               :modal-append-to-body="false">
      <el-form label-width="100px">
        <el-form-item label="适用人群">
          <div class="range-input-row">
            <div class="range-input-row">
              <el-input-number v-model="editFormModel.minAge" controls-position="right"
                               @blur="handleSyncVal('minAge', 'maxAge')"/>
              <span class="range-separator">-</span>
              <el-input-number v-model="editFormModel.maxAge" controls-position="right"/>
            </div>
            <el-select v-model="editFormModel.ageUnit">
              <el-option value="month" label="月" />
              <el-option value="year" label="岁" />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="营养元素">
          <el-select v-model="editFormModel.refElement" filterable clearable :placeholder="$t('请选择')">
            <el-option v-for="opt in elList" :key="opt.flag" :label="opt.name" :value="opt.flag"/>
          </el-select>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="editFormModel.gender" filterable clearable :placeholder="$t('请选择')">
            <el-option label="男" value="man"/>
            <el-option label="女" value="woman"/>
          </el-select>
        </el-form-item>
        <el-form-item label="活动水平">
          <el-select v-model="editFormModel.refLabor" filterable clearable :placeholder="$t('请选择')">
            <el-option v-for="opt in laborList" :key="opt.code" :label="opt.name" :value="opt.code"/>
          </el-select>
        </el-form-item>
        <el-form-item label="算法A">
          <el-select v-model="editFormModel.refAlgorithm" filterable clearable :placeholder="$t('请选择')">
            <el-option v-for="opt in algorithmList" :key="opt.code" :label="opt.algo" :value="opt.code"/>
          </el-select>
        </el-form-item>
        <el-form-item label="算法B">
          <el-select v-model="editFormModel.refAlgorithmMax" filterable clearable :placeholder="$t('请选择')">
            <el-option v-for="opt in algorithmList" :key="opt.code" :label="opt.algo" :value="opt.code"/>
          </el-select>
          <span class="tip el-icon-warning-outline">当推荐值是区间值是需配置两个算法</span>
        </el-form-item>
        <el-form-item label="PA值" v-if="editFormModel.refAlgorithm">
          <el-input-number v-model="editFormModel.pa" controls-position="right" placeholder="请输入PA值" />
        </el-form-item>
        <el-form-item label="推荐摄入量">
          <div class="range-input-row">
            <el-input-number v-model="editFormModel.min" controls-position="right"
                             @blur="handleSyncVal('min', 'max')"
                             :disabled="editDialogVisible.refAlgorithm" />
            <span class="range-separator">-</span>
            <el-input-number v-model="editFormModel.max"
                             controls-position="right"
                             :disabled="editDialogVisible.refAlgorithmMax" />
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="handleSave">保存</el-button>
        <el-button @click="editDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import AnkhList from '@/components/list/AnkhList.vue'
import {request, requestByTip} from '@/config/request'

export default {
  name: 'RecommendConfigViewList',
  components: {AnkhList},
  data() {
    return {
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 选中的行数据
      selectedRows: [],
      // 编辑弹窗状态与表单模型
      editDialogVisible: false,
      editFormModel: {},


      /** 关联数据源 */
      // 性别
      genderMap: {
        man: "男",
        woman: "女"
      },

      elList: [],
      laborList: [],
      algorithmList: [],
    }
  },
  created() {
    // 加载数据
    this.loadData()
    this.loadAllOptions();
  },
  methods: {
    // 填写最小值后需用同步到最大值（通用方法）
    handleSyncVal(valKey, key) {
      this.editFormModel[key] = this.editFormModel[valKey];
    },

    // 从后端加载数据
    async loadData() {
      this.loading = true
      try {
        // 调用真实接口获取数据
        const params = {
          refRecommend: this.$route.query.code,
          onPage: false
        }
        const resp = await request(this.$api.nutriRecommend.list, params, {isJson: false})
        // 将后端数据转换为页面显示格式
        // this.tableData = this.convertBackendDataToDisplay(resp.items || [])
        this.tableData = resp.items.map(item => {
          const isYear = this.getAgeUnit(item);
          return {
            ...item,
            ageUnit: isYear ? 'year' : 'month',
            minAge: isYear ? Math.round(item.minAge / 12) : item.minAge,
            maxAge: isYear ? Math.round(item.maxAge / 12) : item.maxAge
          }
        })
        console.log('tableData', this.tableData);
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
        this.tableData = []
      } finally {
        this.loading = false
      }
    },

    // 获取年龄单位
    getAgeUnit(item) {
      // 处理年龄范围：minAge/maxAge -> ageRange
      if (item.minAge !== undefined || item.maxAge !== undefined) {
        // 判断年龄单位：如果都大于等于12个月，则显示为年
        const minAge = item.minAge || 0
        const maxAge = item.maxAge || 0
        return minAge >= 12 && maxAge >= 12
      }
      return false;
    },

    // 格式化年龄范围显示
    formatAgeRange(item) {
      if (!item || item.minAge === null || item.minAge === undefined || item.maxAge === null || item.maxAge === undefined) {
        return '-'
      }
      const unitText = item.ageUnit === 'year' ? '岁' : '月'
      return `${item.minAge}-${item.maxAge}${unitText}`
    },

    // 格式化数值范围显示
    formatRange(item) {
      if (!item || item.min === null || item.min === undefined) {
        return '-'
      }

      if(item.max === null || item.max === undefined) {
        return item.min;
      }

      return `${item.min}-${item.max}`
    },

    /** 加载数据源 */

    // 营养元素
    async loadEl() {
      try {
        const res = await request(this.$api.elementSort.list, {onPage: false, refRecommend: this.refRecommend});
        this.elList = res.elementSorts;
      } catch (err) {
        console.error(err);
      }
    },

    // 活动水平
    async loadLabor() {
      try {
        const res = await request(this.$api.labor.list, {onPage: false, refRecommend: this.refRecommend});
        this.laborList = res.labors;
      } catch (err) {
        console.error(err);
      }
    },

    // 算法
    async loadAlgorithm() {
      try {
        const res = await request(this.$api.algo.list, {onPage: false, refRecommend: this.refRecommend});
        this.algorithmList = res.algos || [];
      } catch (err) {
        console.error(err);
      }
    },

    // 汇总资源请求统一
    async loadAllOptions() {
      await Promise.all([
        this.loadEl(),
        this.loadLabor(),
        this.loadAlgorithm(),
      ])
    },

    // 新增按钮点击事件
    onAdd() {
      // 跳转到表单页面进行新增
      this.$router.push({
        path: '/recommend-config/add',
        query: this.$route.query
      })
    },

    // 编辑
    handleEdit(row) {
      this.editFormModel = {...row};
      this.editDialogVisible = true;
    },

    // 保存编辑
    async handleSave() {
      // 转换为后端结构并保存
      const payloadRow = {...this.editFormModel};

      // 转换年龄
      if (payloadRow.ageUnit === 'year') {
        payloadRow.minAge = Math.round(payloadRow.minAge * 12);
        payloadRow.maxAge = Math.round(payloadRow.maxAge * 12);
      }
      delete payloadRow.ageUnit;

      try {
        await request(this.$api.nutriRecommend.update, payloadRow)
        this.$message.success('保存成功')
        this.editDialogVisible = false
        await this.loadData()
      } catch (e) {
        console.error(e)
      }
    },


    // 删除按钮点击事件
    async onDelete(row) {
      try {
        await requestByTip(this.$api.nutriRecommend.delete, {code: row.code})
        this.$message.success('删除成功')
        // 重新加载数据
        await this.loadData()
      } catch (error) {
        console.error('删除失败:', error)
      }
    },

    // 选择框变化事件
    onCheckboxChange({records}) {
      this.selectedRows = records
    },

    // 全选/取消全选事件
    onCheckboxAll({records}) {
      this.selectedRows = records
    },

    // 批量删除
    async onBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要删除的记录')
        return
      }

      try {
        const codes = this.selectedRows.map(item => item.code)
        await requestByTip(
            this.$api.nutriRecommend.batchDelete,
            codes,
            {isJson: true},
            {message: '您现在正在进行批量删除操作, 是否继续?'}
        )
        this.$message.success(`成功删除 ${this.selectedRows.length} 条记录`)
        // 清空选中状态
        this.selectedRows = []
        // 重新加载数据
        await this.loadData()
      } catch (error) {
        console.error('批量删除失败:', error)
      }
    },
  },
  computed: {
    refRecommend() {
      return this.$route.query.code;
    },

    // 元素map
    elMap() {
      const mapping = {};
      this.elList.forEach(item => {
        mapping[item.flag] = item.name;
      });
      return mapping;
    },

    // 活动水平map
    laborMap() {
      const mapping = {};
      this.laborList.forEach(item => {
        mapping[item.code] = item.name;
      });
      return mapping;
    },

    // 算法map
    algorithmMap() {
      const mapping = {};
      this.algorithmList.forEach(item => {
        mapping[item.code] = item.algo;
      });
      return mapping;
    }
  }
}
</script>

<style scoped>
.table-scroll-x {
  overflow-x: auto;
}

.table-scroll-x .vxe-table {
  min-width: 720px; /* 兜底最小宽度，确保出现横向滚动 */
}

/* 表格滚动条样式优化 */
.vxe-table .vxe-table--body-wrapper::-webkit-scrollbar {
  height: 8px;
}

.vxe-table .vxe-table--body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.vxe-table .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.vxe-table .vxe-table--body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.el-select {
  width: 100%;
}

.range-input-row {
  display: flex;
  gap: 8px;
}

.tip {
  color: #909399;
}

</style>
